module.exports = __webpack_public_path__ + "img/air.b3fb80c4.gif";